import React, { useEffect, useState } from 'react';

import ArticleFlow from 'components/contentLayouts/ArticleFlow';
import PropTypes from 'prop-types';
import { Search } from 'libs/Algolia-v2';
import colors from 'config/theme/colors';
import decodeHTMLEntities from '@nwg/core-web/utils/decodeHTMLEntities';
import { transformArticleCard } from 'utils/dataTransformers/article';
import transformButtons from 'libs/wordpress/utils/transformButtons';
import { useSelector } from 'react-redux';

// Pure CMS data transformation before we send it to the "real" block!
const ArticleFlowBlock = ({ content = {}, moduleTextColor = '' }) => {
    const { articles_selection: articlesSelection, buttons, heading } = content;
    const articlesData = articlesSelection[0];
    const appID = useSelector(state => state.application.applicationId);

    // Transform color data
    const ligthTheme = moduleTextColor === 'white';
    const textColor = ligthTheme ? colors.white : colors.black;
    const buttonTheme = ligthTheme ? 'outlinedWhite' : 'outlinedBlack';

    // Result from Algolia search
    const [articles, setArticles] = useState(null);

    // Algolia filter search which returns an array with articles
    useEffect(() => {
        let filters = null;

        switch (articlesData.layout) {
            case 'manual':
                filters = articlesData.articles.map(item => {
                    const id = item.article.article;
                    return `id = ${id}`;
                });
                break;
            case 'category':
                filters = [`categories_ids: ${articlesData.Category}`];
                break;
            case 'tags':
                filters = [`tags_ids: ${articlesData.tags}`];
                break;
            default:
                break;
        }

        const allFilters = [
            // Add application id to get the correct market
            [`application_id: ${appID}`],
            filters,
        ];

        if (filters) {
            Search(`articles`, '', {
                filters: allFilters,
                length: 3,
                offset: 0,
            }).then(response => {
                const result = response?.results?.[0] || [];
                if (result) {
                    const transformedArticles = result.hits.map(article => transformArticleCard(article));

                    // Save articles
                    setArticles(transformedArticles);
                }
            });
        }
    }, [articlesData]);

    if (!articles) {
        return null;
    }

    return (
        <ArticleFlow
            articles={articles}
            buttons={buttons ? transformButtons(buttons, { theme: buttonTheme }) : null}
            heading={heading ? decodeHTMLEntities(heading.text) : null}
            headingTag={heading ? heading.type : null}
            textColor={textColor}
        />
    );
};

ArticleFlowBlock.propTypes = {
    content: PropTypes.shape({
        'articles_selection': PropTypes.arrayOf(PropTypes.object),
        heading: PropTypes.object,
        buttons: PropTypes.array,
    }).isRequired,
    moduleTextColor: PropTypes.string,
};

export default ArticleFlowBlock;
